import {Mixpanel} from 'analytics/mixpanel'
import {useSearchParams} from 'next/navigation'
import {useEffect} from 'react'

export const useTrackEvent = (eventKey: string, keysToFetchFromUrl: any[]) => {
  const searchParams = useSearchParams()
  const track = keysToFetchFromUrl.reduce((acc, key) => {
    const value = searchParams.get(key)
    if (value) {
      acc[key] = value
    }
    return acc
  }, {})

  useEffect(() => {
    Mixpanel.track(eventKey, track)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, track])
}
